import { WALL_H_M } from "../geometry/buildingDimensions";
import {
	BENCH_FRAME_HEIGHT_MM,
	BENCH_LEDGER_HEIGHT_MM,
	BENCH_SLAT_THICKNESS_MM,
	LOWER_BENCH_TOP_BELOW_WALL_TOP_M,
	UPPER_BENCH_TOP_BELOW_WALL_TOP_M,
} from "./constants";
import type { BenchRun, InteriorLayout, InteriorRoom } from "./types";

/** All height editors use this transaction. Groups are scoped to one room. */
export function setBenchGroupSeatTopMm(
	layout: InteriorLayout,
	runId: string,
	valueMm: number,
	rooms: readonly InteriorRoom[],
): InteriorLayout {
	const selected = layout.benchRuns.find((r) => r.id === runId);
	if (!selected) return layout;
	const height = rooms.find((r) => r.id === selected.room)?.wallHeightMm;
	const delta = valueMm - benchSeatTopMm(selected, height);
	if (delta === 0) return layout;
	return {
		...layout,
		benchRuns: layout.benchRuns.map((r) =>
			r.id === selected.id ||
			(selected.heightGroupId &&
				r.room === selected.room &&
				r.heightGroupId === selected.heightGroupId)
				? { ...r, seatHeightMm: benchSeatTopMm(r, height) + delta }
				: r,
		),
	};
}

/** Physical seat top, shared by editing, validation, supports and rendering. */
export function benchSeatTopMm(
	run: BenchRun,
	wallHeightMm = WALL_H_M * 1000,
): number {
	if (run.seatHeightMm !== undefined) return run.seatHeightMm;
	if (run.legHeightMm !== undefined && run.legHeightMm > 0)
		return run.legHeightMm + BENCH_SLAT_THICKNESS_MM;
	return (
		wallHeightMm -
		(run.tier === "upper"
			? UPPER_BENCH_TOP_BELOW_WALL_TOP_M
			: LOWER_BENCH_TOP_BELOW_WALL_TOP_M) *
			1000 +
		BENCH_SLAT_THICKNESS_MM / 2
	);
}

/** Assembly bounds, not a recommendation for bathing ergonomics. */
export function benchSeatHeightBoundsMm(wallHeightMm = WALL_H_M * 1000) {
	return {
		minMm:
			BENCH_FRAME_HEIGHT_MM + BENCH_LEDGER_HEIGHT_MM + BENCH_SLAT_THICKNESS_MM,
		maxMm: wallHeightMm - BENCH_SLAT_THICKNESS_MM,
	};
}
